import { Document, RoadmapTasks, User } from "@models";
import { TemplateConfig } from "@types";
import { getDocumentContexts } from "@utils";
import { useMemo } from "react";
import { DocWarnings } from "./DocWarnings";

interface DocumentContextWarningsProps {
  deviceId: string;
  documents: Document[];
  orgId: string;
  tasks: RoadmapTasks;
  templateKey?: string | null;
  templatesConfig: TemplateConfig;
  user: User;
  wrapperClassName?: string;
}

export const DocumentContextWarnings = ({
  deviceId,
  documents,
  orgId,
  tasks,
  templateKey,
  templatesConfig,
  user,
  wrapperClassName,
}: DocumentContextWarningsProps) => {
  const incompleteTemplates = useMemo(() => {
    if (!templateKey) {
      return [];
    }

    return getDocumentContexts({
      templateKey,
      documents,
      user,
      orgId,
      templatesConfig,
    }).incompleteTemplates;
  }, [documents, orgId, templateKey, templatesConfig, user]);

  if (!templateKey || incompleteTemplates.length === 0) {
    return null;
  }

  const warning = (
    <DocWarnings
      deviceId={deviceId}
      incompleteTemplates={incompleteTemplates}
      size="small"
      tasks={tasks}
      templatesConfig={templatesConfig}
    />
  );

  if (!wrapperClassName) {
    return warning;
  }

  return <div className={wrapperClassName}>{warning}</div>;
};
